export class Formatter {
  public pattern: string;
  public expression: RegExp;

  constructor(pattern?: string, expression?: RegExp) {
    switch (arguments.length) {
      case 1:
        this.constructor_B(pattern);
        break;
      case 2:
        this.constructor_C(pattern, expression);
        break;
      default:
        this.constructor_A();
        break;
    }
  }

  private constructor_A(): void {
    this.pattern = '';
  }

  private constructor_B(pattern: string): void {
    this.pattern = pattern;
  }

  private constructor_C(pattern: string, expression: RegExp): void {
    this.pattern = pattern;
    this.expression = expression;
  }

  public apply(value: string): string {
    let reserve = this.pattern.replace(/\*/, 'g');
    let applied = '';
    let ordinal = 0;

    for (let i = 0; i < value.length; i++) {
      if (i < this.pattern.length) {
        if (value[i] === this.pattern[ordinal]) {
          applied += value[i];
          ordinal++;
        } else if (reserve.indexOf(value[i]) > -1) {
        } else {
          while (
            ordinal < this.pattern.length &&
            this.pattern[ordinal] !== '*'
          ) {
            applied += this.pattern[ordinal];
            ordinal++;
          }
          applied += value[i];
          ordinal++;

          while (
            ordinal < this.pattern.length &&
            this.pattern[ordinal] !== '*'
          ) {
            applied += this.pattern[ordinal];
            ordinal++;
          }
        }
      }
    }

    return applied;
  }

  public clearFormat(value: string): string {
    if (value) {
      return value.replace(this.expression, '');
    }

    return value;
  }
}
